import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const useGameStore = create(
  persist(
    (set, get) => ({
      // Player data
      nickname: '',
      avatarId: 1,
      totalScore: 0,
      dailyScore: 0,
      gamesPlayed: 0,
      correctGuesses: 0,
      jailBirdBonusesWon: 0,
      isPremium: false,
      
      // Game history
      gameHistory: [],
      
      // Settings
      soundEnabled: true,
      
      // Actions
      setNickname: (nickname) => set({ nickname }),
      setAvatarId: (avatarId) => set({ avatarId }),
      
      setScore: (score) => set({ totalScore: score }),
      
      addScore: (points) => set((state) => {
        const newState = { 
          totalScore: state.totalScore + points,
          dailyScore: state.dailyScore + points
        };
        // Trigger storage event to notify other tabs/components
        window.dispatchEvent(new Event('storage'));
        return newState;
      }),
      
      incrementGamesPlayed: () => set((state) => {
        const newState = { 
          gamesPlayed: state.gamesPlayed + 1 
        };
        // Trigger storage event to notify other tabs/components
        window.dispatchEvent(new Event('storage'));
        return newState;
      }),
      
      incrementCorrectGuesses: () => set((state) => ({ 
        correctGuesses: state.correctGuesses + 1 
      })),
      
      incrementJailBirdBonuses: () => set((state) => ({
        jailBirdBonusesWon: state.jailBirdBonusesWon + 1
      })),
      
      addGameToHistory: (gameData) => set((state) => ({
        gameHistory: [gameData, ...state.gameHistory].slice(0, 10) // Keep last 10 games
      })),
      
      toggleSound: () => set((state) => ({ soundEnabled: !state.soundEnabled })),
      
      setPremium: (isPremium) => set({ isPremium }),
      
      resetDailyScore: () => set({ dailyScore: 0 }),
      
      reset: () => set({
        nickname: '',
        avatarId: 1,
        totalScore: 0,
        dailyScore: 0,
        gamesPlayed: 0,
        correctGuesses: 0,
        jailBirdBonusesWon: 0,
        gameHistory: []
      })
    }),
    {
      name: 'game-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useGameStore;
